.newComment {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: -5px;
  height: 47px;

  .input {
    height: 40px;
    caret-color: var(--selected-stroke);
  }
}
